import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-small);
	align-items: baseline;

	& > :first-child {
		flex-shrink: 0;
	}
`;
